import React, { createContext, useState, useEffect, useContext } from 'react';

const DataContext = createContext();
const API_URL = `/api`;

export const DataProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [availableTables, setAvailableTables] = useState([]);

  // Fungsi untuk memaksa refresh data
  const refreshData = () => setRefreshTrigger(prev => prev + 1);

  // Fungsi untuk mengambil data dari API
  const fetchData = async (table) => {
    try {
      const response = await fetch(`${API_URL}/data/${table}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${table} data`);
      }
      return await response.json();
    } catch (err) {
      console.error(`Error fetching ${table} data:`, err);
      throw err;
    }
  };

  // Fungsi untuk menjalankan query SQL kustom
  const executeQuery = async (query, params = {}, databaseId = null) => {
    try {
      console.log('DataContext - Query:', query);
      console.log('DataContext - Params received:', params);
      console.log('DataContext - Params types:', Object.entries(params).map(([key, val]) => 
        `${key}: ${typeof val} = ${val}`
      ));
      
      const response = await fetch(`${API_URL}/query`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query, params, databaseId }),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to execute query');
      }
      
      return await response.json();
    } catch (err) {
      console.error('Error executing query:', err);
      throw err;
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        // Ambil daftar tabel yang tersedia
        const tablesResponse = await fetch(`${API_URL}/tables`);
        const tables = await tablesResponse.json();
        setAvailableTables(tables);
      } catch (err) {
        console.error('Error loading data:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchAllData();
  }, [refreshTrigger]);

  return (
    <DataContext.Provider value={{
      isLoading, 
      error,
      refreshData,
      availableTables,
      fetchData,
      executeQuery
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
